import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import StepperContext from '../stepper-context';

const StepperContent = ({ id, children }) => {
  const { displayedStepId, prevStepId } = useContext(StepperContext);

  if (displayedStepId !== id && prevStepId !== id) {
    return null;
  }

  return (
    <div
      key={id}
      className={classNames('ws-stepper__content', {
        'ws-stepper__content--fade-in': displayedStepId === id,
        'ws-stepper__content--fade-out': prevStepId === id,
        'ws-stepper__content--outgoing': prevStepId === id,
      })}
    >
      {children}
    </div>
  );
};

StepperContent.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default StepperContent;
